import React, { Component, useEffect, useState } from 'react';

import { api_url, image_url } from '../config';
import { Link } from 'react-router-dom';
import Breadcrumb from "./breadcrumb";
import './../css/othertemplate.css';


const OtherTemplate = (props) => {
    
    let imgURL = image_url;

    const [bannerImage, setBannerImage] = useState();
    const [pageBreadcrumb, setBreadcrumb] = useState();
    const [firstSectionData, setFirstSectionData] = useState();

    const pageInfo = props?.data?.[0]?.[0];

     const bannerData = props?.data?.find(
        (section) => section?.[0]?.section_name === "banner"
    )?.[0];

    const contentSections =
    props?.data?.find(
      (section) => section?.[0]?.section_name === "second_section"
    ) || [];

    const breadcrumbObject = {
        img: bannerData?.image
        ? image_url + "banner_image/" + bannerData.image
        : "",
        breadcumbs: pageInfo?.page_name || "",
    };
 


    return (
        <>
            <Breadcrumb data={breadcrumbObject} />
            
            <section className="main_content_details homeBottomText">
                <div className="details_section">
                    {contentSections.length > 0 &&
                        contentSections.map((item, index) => (
                            <React.Fragment key={index}>
                                <div className="heading_section">
                                    <h1 className="main_heading">
                                        {item.heading}
                                    </h1>
                                </div>

                                <div className="both_section">
                                    <div className="content_section">
                                        <p
                                            className="light-color"
                                            dangerouslySetInnerHTML={{
                                                __html: item.text_content || ""
                                            }}
                                        />
                                    </div>
                                </div>
                            </React.Fragment>
                        ))}
                </div>
            </section>
           
        </>
    );
}

export default OtherTemplate;